import { ChatResult } from "@memberjunction/ai";
import { RegisterClass } from "@memberjunction/global";
import { BaseMessageConverter } from "./BaseMessageConverter.js";
import { marked } from "marked";
import { LogError } from "@memberjunction/core";

@RegisterClass(BaseMessageConverter, 'BettyBotLLMConverter')
export class BettyBotLLMConverter extends BaseMessageConverter {
    constructor() {
        super();
    }

    /**
     * Transforms Betty's response from markdown to html.
     * Also concatenates all choices into a single response.
     * @param message 
     * @returns 
     */
    public TransformGeneratedResponse(message: ChatResult): ChatResult {
        try {
            if(!message.success){
                return message;
            }
    
            if(!message.data.choices || message.data.choices.length === 0){
                return message;
            }
    
            let response: string = message.data.choices.map(c => c.message.content).join('\n');
            let markedResponse: string = marked.parse(response, {async: false, gfm: true, breaks: true});
            message.data.choices = [
                {
                    message: {
                        role: 'assistant',
                        content: markedResponse
                    },
                    finish_reason: "",
                    index: 0
                }
            ];
            const clone = structuredClone(message);
            return clone;
        }
        catch(ex){
            LogError(`Error transforming BettyBot response:`, undefined, ex);
            return message;
        }
    }

    public TransformQualityCheckResponse(message: ChatResult): ChatResult {
        return message;
    }
}

export function LoadBettyBotMessageConverter(): void {

}